export default {
    //all products here....
    products: [

        {
            _id: "1",
            title_: "Nike Hoodie",
            image: require("../images/fl.jpg"),
            description:"The Nike Standard Issue Pullover Hoodie is made to play in and wear all day",
            price: 600000,
            category: "men",
            brand: "Bantu",
            closeUpOne: require("../images/closeUpOne.png"),
            closeUpTwo: require("../images/closeUptwo.png"),
            status: "InStock",
            rating: 3,
        },

        {
            _id: "2",
            title_: "Joggers",
            image: require("../images/fl.jpg"),
            description:"The Nike Standard Issue Pullover Hoodie is made to play in and wear all day",
            price: 600000,
            closeUpOne: require("../images/closeUpOne.png"),
            closeUpTwo: require("../images/closeUptwo.png"),
            category: "women",
            brand: "Zuula",
            status: "InStock",
            rating: 2,
        },


        {
            _id: "3",
            title_: "Fleece Joggers",
            image: require("../images/winter.jpg"),
            description:"The Nike Standard Issue Pullover Hoodie is made to play in and wear all day",
            price: 40000,
            category: "men",
                  closeUpOne: require("../images/closeUpOne.png"),
            closeUpTwo: require("../images/closeUptwo.png"),
            brand: "House Of Shurea Yasmin",
            status: "Out Of Stock",
            rating: 4,
        },

        {
            _id: "4",
            closeUpOne: require("../images/closeUpOne.png"),
            closeUpTwo: require("../images/closeUptwo.png"),
            title_: "Fleece Joggers",
            image: require("../images/fl.jpg"),
            description:"The Nike Standard Issue Pullover Hoodie is made to play in and wear all day",
            price: 40000,
            category: "Men Joggers",
            brand: "Aliad",
            status: "InStock",
            rating: 1,
        },



        {
            _id: "5",
            title_: "Fleece Sweater",
            image: require("../images/fl.jpg"),
            description:"The Nike Standard Issue Pullover Hoodie is made to play in and wear all day",
            price: 110000,
            category: "Men Sweaters",
            brand: "Jamila Brown",
            closeUpOne: require("../images/closeUpOne.png"),
            closeUpTwo: require("../images/closeUptwo.png"),
            status: "InStock",
            rating: 5,
        },

        {
            _id: "6",
            
            closeUpOne: require("../images/closeUpOne.png"),
            closeUpTwo: require("../images/closeUptwo.png"),
            title_: "Nike UpTempo",
            image: require("../images/uptempo.jpg"),
            description:"The Nike Standard Issue Pullover Hoodie is made to play in and wear all day",
            price: 600000,
            category: "Men Shoes",
            brand: "Jamila Brown",
            status: "InStock",
            rating: 6,
        },


        {
            _id: "7",
            closeUpOne: require("../images/closeUpOne.png"),
            closeUpTwo: require("../images/closeUptwo.png"),
            title_: "Hoodie",
            image: require("../images/hoodie.jpg"),
            description:"Create text-searchable PDFs, Capture, Annotate, Print and Save better, Edit, Upload, send to E-MailOneNote, or Export to another program.",
            price: 40000,
            category: "Women",
            brand: "Yasmin K",
            status: "Out of Stock",
            rating: 5,
        },
    ]

  
}